import React, { useState } from 'react';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import '../styles/Modal.css';

const DeleteConfirmModal = ({ item, itemType = 'user', onClose, onDeleted, deleteFunction }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await deleteFunction(item._id);

      if (response.data.success) {
        onDeleted();
      } else {
        setError(response.data.message || `Failed to delete ${itemType}`);
      }
    } catch (err) {
      console.error(`Delete ${itemType} error:`, err);
      const message = err.response?.data?.message || `An error occurred while deleting the ${itemType}`;
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const capitalizedItemType = itemType.charAt(0).toUpperCase() + itemType.slice(1);

  return (
    <div className="modal-overlay">
      <div className="modal modal-small">
        <div className="modal-header">
          <h2>Delete {capitalizedItemType}</h2>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="delete-confirm-content">
            <FaExclamationTriangle className="warning-icon" />
            <p className="confirm-message">
              Are you sure you want to delete <strong>{item?.name || item?.title}</strong>?
            </p>
            <p className="confirm-submessage">
              This action cannot be undone.
            </p>
          </div>

          {error && (
            <div className="error-alert">{error}</div>
          )}

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDelete}
              disabled={loading}
            >
              {loading ? 'Deleting...' : `Delete ${capitalizedItemType}`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
